import React from 'react';
import PublicPageLayout from '../components/landing-page/PublicPageLayout';

const assets = [
  { name: 'Primary Logo Pack', type: 'SVG, PNG', usage: 'Product screens and partner pages' },
  { name: 'Brand Guidelines', type: 'PDF', usage: 'Typography, color, and spacing guidance' },
  { name: 'Product Screenshots', type: 'PNG', usage: 'Press kits and launch announcements' },
];

export default function MarketingAssetsPage() {
  return (
    <PublicPageLayout title='Marketing Assets' subtitle='Approved brand materials and usage guidance.'>
      <p>Use these resources when featuring PricingTable AI in partner announcements, media mentions, and customer stories.</p>
      <div className='grid gap-4 md:grid-cols-2'>
        {assets.map((asset) => (
          <article key={asset.name} className='rounded-lg border border-gray-700 bg-gray-900/40 p-5'>
            <h2 className='text-lg font-semibold text-white'>{asset.name}</h2>
            <p className='mt-2 text-sm text-gray-300'>Format: {asset.type}</p>
            <p className='mt-1 text-sm text-gray-300'>Best use: {asset.usage}</p>
            <button className='mt-4 rounded-md border border-gray-500 px-3 py-2 text-xs font-medium text-gray-200 hover:border-yellow-500 hover:text-yellow-300'>
              Download (Demo)
            </button>
          </article>
        ))}
      </div>
    </PublicPageLayout>
  );
}
